import { useStore } from '../state/store'
import { IconClose, IconKeyboard } from './icons'

const GROUPS: { title: string; rows: { keys: string[]; what: string }[] }[] = [
  {
    title: 'Canvas',
    rows: [
      { keys: ['Scroll'], what: 'Zoom at the cursor' },
      { keys: ['Drag'], what: 'Pan (empty area)' },
      { keys: ['Space', 'Drag'], what: 'Pan anywhere' },
      { keys: ['F'], what: 'Fit view' },
      { keys: ['Esc'], what: 'Cancel placement / close' },
    ],
  },
  {
    title: 'Controllers (canvas focused)',
    rows: [
      { keys: ['Tab'], what: 'Cycle controllers' },
      { keys: ['Arrows'], what: 'Nudge 1 mm (Shift 10, Alt 0.1)' },
      { keys: ['Del'], what: 'Delete selected' },
      { keys: ['Drag ring'], what: 'Resize influence' },
      { keys: ['Snap'], what: 'Center, edges, thirds, quarters, 1 mm' },
      { keys: ['Enter'], what: 'Finish curve/polyline placement' },
      { keys: ['2x click'], what: 'Node: delete. Spine: insert node' },
      { keys: ['R-click'], what: 'Controller options menu' },
    ],
  },
  {
    title: 'Values',
    rows: [
      { keys: ['Drag label'], what: 'Scrub value' },
      { keys: ['Arrows'], what: 'Step value' },
      { keys: ['Shift'], what: 'Coarse steps (x10)' },
      { keys: ['Alt'], what: 'Fine steps (x0.1)' },
      { keys: ['Enter'], what: 'Commit typed value' },
    ],
  },
  {
    title: 'Application',
    rows: [
      { keys: ['1', '...', '9'], what: 'Switch layout mode' },
      { keys: ['S', 'P', 'A', 'M'], what: 'Size / Spacing / Angle / Shape channel' },
      { keys: ['R'], what: 'Shuffle seed' },
      { keys: ['E'], what: 'Export dialog' },
      { keys: ['H'], what: 'Undo history' },
      { keys: ['Ctrl/Cmd', 'Z'], what: 'Undo (Shift: redo)' },
      { keys: ['Ctrl/Cmd', 'K'], what: 'Command palette' },
      { keys: ['?'], what: 'This sheet' },
    ],
  },
]

export function ShortcutSheet() {
  const setOverlay = useStore((s) => s.setOverlay)
  return (
    <div className="dialog shortcut-sheet holo-frame" role="dialog" aria-modal="true" aria-label="Keyboard shortcuts">
      <div className="dialog-head">
        <IconKeyboard size={16} />
        <h2>Keyboard map</h2>
        <button className="quiet icon-btn" onClick={() => setOverlay(null)} aria-label="Close (Esc)">
          <IconClose size={13} />
        </button>
      </div>
      <div className="dialog-body">
        <div className="shortcut-grid">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <div className="palette-section" style={{ paddingLeft: 0 }}>
                {g.title}
              </div>
              {g.rows.map((r) => (
                <div className="shortcut-row" key={r.what}>
                  <span>{r.what}</span>
                  <span className="shortcut-keys">
                    {r.keys.map((k, i) => (
                      <kbd key={i}>{k}</kbd>
                    ))}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
